var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Link2 = function Link2(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M16.5 2.964a4.536 4.536 0 0 0-3.207 1.329l-.5.5a1 1 0 0 0 1.414 1.414l.5-.5a2.535 2.535 0 1 1 3.586 3.586l-4 4-.007.007a2.5 2.5 0 0 1-3.572 0 1 1 0 1 0-1.428 1.4 4.5 4.5 0 0 0 6.425.004l3.996-3.997A4.535 4.535 0 0 0 16.5 2.964Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M11.5 7.95a4.5 4.5 0 0 0-3.21 1.346l-3.997 3.997a4.536 4.536 0 0 0 6.414 6.414l.5-.5a1 1 0 0 0-1.414-1.414l-.5.5a2.535 2.535 0 0 1-3.586-3.586l4-4 .007-.007a2.5 2.5 0 0 1 3.572 0 1 1 0 0 0 1.428-1.4A4.5 4.5 0 0 0 11.5 7.95Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Link2;